
export const config = {
        subdomain: 'iftpuodplxsmphfxwotj', 
        region: 'eu-central-1'
}